export default "__VITE_ASSET__BV2$jTkw__"